const dragClass = 'is-dragging';
const draggables = [...document.getElementsByClassName('js-draggable')];
draggables.forEach((draggable) => {
  let isDown = false;
  let startX;
  let scrollLeft;

  const handleDragEnd = () => {
    isDown = false;
    draggable.classList.remove(dragClass);
  };

  draggable.addEventListener("mouseleave", handleDragEnd);
  draggable.addEventListener("mouseup", handleDragEnd);

  draggable.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - draggable.offsetLeft;
    scrollLeft = draggable.scrollLeft;
  });

  draggable.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    const x = e.pageX - draggable.offsetLeft - startX;
    if (scrollLeft === scrollLeft - x) return;

    e.preventDefault();
    draggable.classList.add(dragClass);
    draggable.scrollLeft = scrollLeft - x;
  });

  const nextButton = draggable.nextElementSibling;
  if (nextButton) {
    const lastItem = document.querySelector('.search-filters__filters > *:last-child');
    if (!lastItem) return;

    nextButton.addEventListener('click', () => {
      draggable.scrollTo({
        left: lastItem.getBoundingClientRect().right,
        behavior: 'smooth'
      })
    })

    const observer = new IntersectionObserver(([e]) => {
      nextButton.classList[e.isIntersecting ? 'add' : 'remove']('hide')
    }, {
      threshold: 1
    })
    observer.observe(lastItem);
  }
})
